export default "__VITE_ASSET__CmpXAk89__"